<template>
  <img
    :src="url"
    :alt="alt"
    :style="{ width: `${size}px`, height: `${size}px` }"
  />
</template>

<script>
import crypto from 'crypto'

export default {
  props: {
    email: {
      type: String
    },

    hash: {
      type: String,
      default: ''
    },

    size: {
      type: Number,
      default: 'retro'
    },

    defaultImg: {
      type: String,
      default: 'retro'
    },

    forceDefault: {
      type: Boolean,
      default: false
    },

    rating: {
      type: String,
      default: 'g'
    },

    alt: {
      type: String,
      default: 'Avatar'
    }
  },

  computed: {
    url() {
      const img = [
        '//www.gravatar.com/avatar/',
        this.hash || this.emailHash,
        `?s=${this.size * 4}`,
        `&d=${this.defaultImg}`,
        `&r=${this.rating}`
      ]

      if (this.forceDefault) {
        img.push('&f=y')
      }

      return img.join('')
    },

    emailHash() {
      return crypto
        .createHash('sha256')
        .update(this.email.trim().toLowerCase(), 'utf8')
        .digest('hex')
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/components/Gravatar.vue